import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthLayout } from '../../complexes/AuthLayout'
import styles from './RecoveryPasswordSuccess.module.scss'

const RecoveryPasswordSuccess: FC = () => {
    const { t } = useTranslation()

    return (
        <AuthLayout>
            <div className={styles.root}>
                <h3 className={styles.header}>
                    {t('438_RecoveryPasswordSuccess_passwordRecovery')}
                </h3>
                <p className={styles.text}>
                    {t('439_RecoveryPasswordSuccess_message')}
                </p>
            </div>
        </AuthLayout>
    )
}

export default RecoveryPasswordSuccess
